/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Tenant_Selection_WelcomeInputs */

const es_tenant_selection_welcome = /** @type {(inputs: Tenant_Selection_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bienvenido ${i?.name}`)
};

const en_tenant_selection_welcome = /** @type {(inputs: Tenant_Selection_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welcome ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Welcome {name}" |
*
* @param {Tenant_Selection_WelcomeInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tenant_selection_welcome = /** @type {((inputs: Tenant_Selection_WelcomeInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tenant_Selection_WelcomeInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tenant_selection_welcome(inputs)
	return en_tenant_selection_welcome(inputs)
});
export { tenant_selection_welcome as "tenant-selection.welcome" }